/**
 * CitationPill — inline citation badge rendered inside AI chat messages.
 *
 * Two modes:
 *   mode='source' (default) — Lib Chat: shows source number, tooltip = article title
 *   mode='block'            — Article Chat: shows ¶N, tooltip = "Paragraph N", click scrolls to block
 *
 * Subtle neutral style (not primary color) to avoid being too eye-catching.
 * On click: triggers onCitationClick(number, source) for navigation.
 */

const CitationPill = ({ number, source, onClick, mode = 'source' }) => {
  const isBlock = mode === 'block';
  const title = isBlock ? `Paragraph ${number}` : (source?.article_title || `Source ${number}`);
  const label = isBlock ? `¶${number}` : number;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(number, source);
  };

  return (
    <button
      className="citation-pill"
      onClick={handleClick}
      title={title}
      aria-label={isBlock ? `Paragraph ${number}` : `Citation ${number}: ${title}`}
    >
      {label}
    </button>
  );
};

export default CitationPill;
